import React, { createContext, useState, useEffect } from 'react';
import { getAuthUser, loginUser, registerUser, impersonateUser } from '../api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);
  const [isImpersonating, setIsImpersonating] = useState(!!localStorage.getItem('originalToken'));

  useEffect(() => {
    const loadUser = async () => {
      if (token) {
        try {
          const res = await getAuthUser();
          setUser(res.data);
        } catch (err) {
          console.error("Failed to authenticate user", err);
          setToken(null);
          localStorage.removeItem('token');
        }
      }
      setLoading(false);
    };
    loadUser();
  }, [token]);

  const login = async (credentials) => {
    const res = await loginUser(credentials);
    localStorage.setItem('token', res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
  };

  const register = async (userData) => {
    const res = await registerUser(userData);
    localStorage.setItem('token', res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
  };

  const updateUser = (userData) => {
    setUser(userData);
  };

  const impersonate = async (userId) => {
    const res = await impersonateUser(userId);
    // Stash original admin token
    const currentToken = localStorage.getItem('token');
    if (currentToken && !localStorage.getItem('originalToken')) {
      localStorage.setItem('originalToken', currentToken);
      setIsImpersonating(true);
    }
    // Set new impersonated session
    localStorage.setItem('token', res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
    // Redirect to the impersonated user's dashboard
    window.location.href = '/dashboard';
  };

  const stopImpersonating = async () => {
    const originalToken = localStorage.getItem('originalToken');
    if (originalToken) {
      localStorage.setItem('token', originalToken);
      localStorage.removeItem('originalToken');
      setToken(originalToken);
      setIsImpersonating(false);
      // Wait for the useEffect to reload the real admin user data
      // or we can reload the page to ensure clear state
      window.location.href = '/admin';
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, updateUser, isImpersonating, impersonate, stopImpersonating }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
